// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Utils
import { isPlatformAndroid } from '../../platform/utils/platformDetailsUtils';

// Selectors
import { getPlatformDetailsSelector } from '../../platform/platformSelector';

// eslint-disable-next-line react/display-name
export default (DecoratedComponent) => (props) => {
    const platformDetails = useSelector(getPlatformDetailsSelector);
    return isPlatformAndroid(platformDetails) ? <DecoratedComponent {...props} /> : null;
};
